import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-name',
  templateUrl: './dialog-name.component.html',
  styleUrl: './dialog-name.component.scss'
})
export class DialogNameComponent {

  constructor(
    public dialogRef: MatDialogRef<DialogNameComponent>,
    // titulo es opcional: el diálogo nació para nombrar modelos y ese sigue siendo su valor por
    // defecto, pero también se usa para nombrar la lista que crea el screener.
    // maxLength es opcional para que solo lo limiten quienes lo necesitan (nombres de cartera).
    @Inject(MAT_DIALOG_DATA) public data: { name: string, titulo?: string, mensaje?: string, maxLength?: number }
  ) { }

  get longitud(): number {
    return (this.data.name ?? '').trim().length;
  }

  get valido(): boolean {
    return this.longitud > 0 && (!this.data.maxLength || this.longitud <= this.data.maxLength);
  }

  aceptar(): void {
    if (this.valido) this.dialogRef.close(this.data.name.trim());
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

}
